// ketoneLog.js — read/write for breath ketone meter readings.
//
// localStorage["hayahKetoneLog"] = [{ ts, mmol, unit, source, note? }]
//   source: 'manual' | 'photo'
//   unit:   'mmol/L' | 'ACE' | 'unknown'

const KEY = "hayahKetoneLog";
const CAP = 365;

function load() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}

function save(arr) {
  try { localStorage.setItem(KEY, JSON.stringify(arr.slice(-CAP))); } catch {}
}

// Add a new reading. Dispatches a storage event so HayahToday re-renders.
export function addKetoneReading({ mmol, unit = "mmol/L", source = "manual", note } = {}) {
  const entry = { ts: Date.now(), mmol: parseFloat(mmol) || 0, unit, source };
  if (note) entry.note = String(note);
  const arr = load();
  arr.push(entry);
  save(arr);
  try { window.dispatchEvent(new StorageEvent("storage", { key: KEY })); } catch {}
  return entry;
}

export function getLatestReading() {
  const arr = load();
  return arr.length ? arr[arr.length - 1] : null;
}

export function getReadingsInWindow(fromTs, toTs) {
  return load().filter(r => r.ts >= fromTs && r.ts <= toTs);
}

// Returns the most recent reading logged since midnight local time, or null.
export function getTodayReading() {
  const start = new Date(); start.setHours(0, 0, 0, 0);
  const readings = getReadingsInWindow(start.getTime(), Date.now());
  return readings.length ? readings[readings.length - 1] : null;
}
